"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GazeOfPetrificationAbilityHandler = exports.GazeOfPetrificationActorAbilityFactory = exports.GazeOfPetrificationAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const EventType_1 = require("../../core/events/EventType");
const Schedule_1 = require("../../core/Schedule");
class GazeOfPetrificationAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.GazeOfPetrification;
        this.__typeName = "GazeOfPetrification";
    }
}
exports.GazeOfPetrificationAbilityArgs = GazeOfPetrificationAbilityArgs;
let GazeOfPetrificationActorAbilityFactory = class GazeOfPetrificationActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("GazeOfPetrification", "Self", 0);
    }
};
GazeOfPetrificationActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("GazeOfPetrification")
], GazeOfPetrificationActorAbilityFactory);
exports.GazeOfPetrificationActorAbilityFactory = GazeOfPetrificationActorAbilityFactory;
let GazeOfPetrificationAbilityHandler = class GazeOfPetrificationAbilityHandler {
    init(sequence, container, actorId) {
        container.applyAbilityAnimation({
            sequence,
            abilityKey: "GazeOfPetrification",
            fallback: "blocked",
            animatedId: actorId,
            onAnimated: sequence => {
                container.applyBuff({
                    sequence,
                    creatorId: actorId,
                    targetId: actorId,
                    duration: Duration_1.Duration.Permanent,
                    effect: new core_1.LinkedEventHandlerEffectArgs("Gaze of Petrification", "Applies slow to enemies on start of turn", false, container.registerEventHandlerScript(actorId, EventType_1.EventType.TurnStarted, Schedule_1.Schedule.Unlimited, "ApplyEffects_OnEvent", {
                        target: Target_1.Target.AllEnemies,
                        effects: [{
                                duration: Duration_1.Duration.Permanent,
                                effect: new core_1.SlowEffectArgs(2)
                            }]
                    })),
                    supernatural: true
                });
            }
        });
    }
    activate(sequence, container, ability) {
        throw new Error("PASSIVE_ONLY");
    }
};
GazeOfPetrificationAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.GazeOfPetrification)
], GazeOfPetrificationAbilityHandler);
exports.GazeOfPetrificationAbilityHandler = GazeOfPetrificationAbilityHandler;
